import { CasePermissions } from 'app/types-shared';

export const ACTION = {
  REQUEST_CASE_ENTITY_ID:  'REQUEST_CASE_ENTITY_ID',
  RECEIVE_CASE_ENTITY_ID:  'RECEIVE_CASE_ENTITY_ID',
  FAIL_REQUEST_CASE_ENTITY_ID: 'FAIL_REQUEST_CASE_ENTITY_ID',
  REQUEST_CONNECTED_CASE_PERMISSIONS: 'REQUEST_CONNECTED_CASE_PERMISSIONS',
  RECEIVE_CONNECTED_CASE_PERMISSIONS: 'RECEIVE_CONNECTED_CASE_PERMISSIONS'
};

export class RequestCaseEntityId {
  public type: string = ACTION.REQUEST_CASE_ENTITY_ID;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class ReceiveCaseEntityId {
  public type: string = ACTION.RECEIVE_CASE_ENTITY_ID;
  public caseId: number;
  public entityId: number;

  constructor(caseId: number, entityId: number) {
    this.caseId = caseId;
    this.entityId = entityId;
  }
}

export class FailRequestCaseEntityId {
  public type: string = ACTION.FAIL_REQUEST_CASE_ENTITY_ID;
  public caseId: number;
  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class RequestConnectedCasePermissions {
  public type: string = ACTION.REQUEST_CONNECTED_CASE_PERMISSIONS;
  constructor(public ids: number[]) {}
}

export class ReceiveConnectedCasePermissions {
  public type: string = ACTION.RECEIVE_CONNECTED_CASE_PERMISSIONS;
  constructor(public permissions: {[id: number]: CasePermissions}) {}
}
